import React from "react";
import LineOrange from "../../../common/LineOrange/LineOrange";
export const Certificate = () => {
  return (
    <>
      <div className="container">
        <div className="text-center mb-5 mt-5">
          <h3>گواهی سپرده کالایی</h3>
          <LineOrange />
          <div className="">
            <p className="text-right mt-3">
              گواهی سپرده کالایی اوراق بهاداری است که مالکیت مقدار معینی کالا را
              تایید می‌کند. پشتوانه این اوراق قبض استانداردی است که توسط
              انبارهای استاندارد بورس کالا صادر می‌شود. در این اوارق، مالک کالا
              (مثل کشاورزان) به یکی از انبارهای پذیرفته شده از سوی بورس کالای
              ایران مراجعه کرده و پس از تودیع کالا، از سوی انباردار، گواهی سپرده
              کالایی دریافت می‌کند. مالک کالا در این مرحله می‌تواند با مراجعه به
              کارگزاری مبین سرمایه درخواست فروش محصول خود در بورس کالا را ارائه
              کند. مالک کالا همچنین با استناد بر این اوراق امکان استفاده از
              خدمات تامین مالی یا اخذ وام بانکی را نیز دارد.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};
